import { jsx } from "react/jsx-runtime";
import React from "react";
var chevron_down_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9999 17.0605 3.9992 9.0593l1.4142-1.4141L12 14.2322l6.5869-6.586 1.4141 1.4143-8.0011 8z" })];
};
export {
  chevron_down_default as default
};
